/* */ 
module.exports = require('./src/instantiator');
